import { render, staticRenderFns } from "./CardTask.vue?vue&type=template&id=3a825a04"
import script from "./CardTask.vue?vue&type=script&lang=js"
export * from "./CardTask.vue?vue&type=script&lang=js"
import style0 from "./CardTask.vue?vue&type=style&index=0&id=3a825a04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports